<template>
    <div class="StorageEquipment">
        <Box title="设备入库">
            <div class="infoBox">
                <Field title="仓库" :text="$UserInfo.StoreName" type="text" :readonly="true" />
                <Field title="入库时间" :text="$format(new Date,'YYYY-MM-DD')" type="text" :readonly="true" />
                <Field name="personnel" @manuconfirm="UpdataData.LXR=arguments[0].a,UpdataData.CGYXM=arguments[0].b"
                    title="采购人" placeholder="请输入" type="manufacturer" />
                <Field name="personnel" @manuconfirm="UpdataData.PZR=arguments[0].a,UpdataData.ZMRXM=arguments[0].b"
                    title="验收人" placeholder="请输入" type="manufacturer" />
                <Field name="personnel" @manuconfirm="UpdataData.CGY=arguments[0].a,UpdataData.CGYSXM=arguments[0].b"
                    title="仓管员" placeholder="请输入" type="manufacturer" :text='UpdataData.CGYSXM' />
                <Field title="备注" placeholder="请输入备注内容" type="textarea" @onMessage="value => UpdataData.BZ = value" />
            </div>
        </Box>
        <Footer button="提交" @change="upload" />
    </div>
</template>

<script>
    import Box from '../..//components/commonBox/commonBox'
    import Field from '../../components/field/field'
    import Footer from '../../components/footer/footer'
    export default {
        name: 'StorageEquipment',
        components: {
            Box,
            Field,
            Footer
        },
        data() {
            return {
                UpdataData: {
                    LXR: '', //采购人编号
                    CGYXM: '', //采购人名称
                    PZR: '', //验收人
                    ZMRXM: '', //验收人姓名
                    CGY: '', //仓管员
                    CGYSXM: '', //仓管员姓名
                    BZ: ''
                }
            }
        },
        mounted() {

            this.$get('api/CheckIncoming/GetAcceptor', { //获取仓管员
                STORE: this.$UserInfo.StoreCode
            }).then(res => {
                if (res) {
                    this.UpdataData.CGY = res.GKHM;
                    this.UpdataData.CGYSXM = res.XM;
                }
            })
        },
        methods: {
            upload() {
                this.$post('api/CheckIncoming/PutInEquipment', {
                    SBBH: this.$route.params.item.SBMCBH,
                    DH: this.$route.params.item.DH,
                    GKHM: this.$UserInfo.UserId,
                    STORE: this.$UserInfo.StoreCode,
                    Model: this.UpdataData
                }).then(result => {
                    debugger
                    if (result.Status) {
                        this.$Toast({
                            message: '入库完成',
                            duration: 1500,
                            onClose: () => {
                                // this.$Bus.$emit('InStorage',{
                                //    SBBH:this.$route.params.item.SBMCBH,
                                //    DH:this.$route.params.item.DH
                                // })
                                this.$router.back();
                            }
                        });
                    } else this.$Toast(result.Msg);
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .StorageEquipment {
        padding-bottom: 112px;
    }

    .infoBox {
        padding: 0 30px;
    }
</style>



// WEBPACK FOOTER //
// src/page/storageEquipment/storageEquipment.vue